import { createContext, useContext, useState, useCallback } from "react";

const T = {
  id: {
    "common.guide": "Panduan",
    "common.manualDownload": "Unduh Panduan Pengguna (PDF)",
    "common.login": "Masuk",
    "common.logout": "Keluar",
    "common.startAnalysis": "Mulai Analisis",
    "common.loading": "memuat…",
    "common.or": "atau",
    "common.save": "Simpan",
    "common.upgrade": "Upgrade",
    "unit.docs": "dok",
    "unit.items": "butir",

    "landing.badge": "Analisis Hukum Berbasis AI",
    "landing.heroA": "Analisis perkara,",
    "landing.heroB": "tergrounding",
    "landing.heroC": " ke setiap sumber.",
    "landing.heroSub": "Platform analisis hukum berbasis AI untuk legal analyst Indonesia.",
    "landing.heroDesc": "Dokumen perkara, kontrak komersial, atau BAP sering berjumlah ratusan hingga ribuan halaman. Platform kami mengatasi information overload — memindai, merangkum kronologi, dan mengekstraksi fakta penting dalam hitungan menit.",
    "landing.stat1": "Tahap SOP",
    "landing.stat2": "Kategori grounded",
    "landing.stat3": "Bukan berhari-hari",
    "landing.stat4": "Ekspor sekali klik",
    "landing.howSmall": "Cara Kerja",
    "landing.howH2": "Tiga langkah menuju laporan",
    "landing.step1t": "Unggah Berkas",
    "landing.step1d": "Seret gugatan, kontrak, bukti, atau putusan. Dokumen scan pun terbaca lewat OCR.",
    "landing.step2t": "Analisis AI",
    "landing.step2d": "AI mengekstrak fakta, klaim, sengketa, bukti, dan isu hukum lintas SOP 15-langkah.",
    "landing.step3t": "Laporan Akhir",
    "landing.step3d": "Kompilasi otomatis menjadi laporan analisis perkara — tergrounding & siap ekspor.",
    "landing.featSmall": "Kemampuan Inti",
    "landing.featH2": "Dari berkas mentah ke strategi litigasi",
    "landing.feat1t": "Pindai & Rangkum",
    "landing.feat1d": "Memindai ratusan halaman gugatan, kontrak, atau BAP lalu merangkum dalam hitungan menit.",
    "landing.feat2t": "Kronologi Otomatis",
    "landing.feat2d": "Rekonstruksi urutan peristiwa perkara otomatis dari fakta yang terekstrak.",
    "landing.feat3t": "Laporan Analisis",
    "landing.feat3d": "Satu klik menghasilkan Laporan Analisis Perkara — siap ekspor PDF & DOCX.",
    "landing.feat4t": "Tergrounding ke Sumber",
    "landing.feat4d": "Setiap fakta & isu hukum tertaut ke dokumen asli + kutipan verbatim — anti-halusinasi.",
    "landing.groundBadge": "Moat Kredibilitas",
    "landing.groundH2": "Bukan sekadar output AI — analisis yang bisa dipertanggungjawabkan.",
    "landing.groundP": "Pertanyaan pertama setiap advokat: \"apakah AI berhalusinasi?\" Di sinilah letak bedanya. Setiap fakta, klaim, dan isu hukum menyimpan kutipan verbatim dari dokumen asli beserta nomor halaman — tinggal klik untuk memverifikasi.",
    "landing.groundB1": "Kutipan verbatim tersimpan saat ekstraksi — tanpa biaya AI tambahan.",
    "landing.groundB2": "Human-in-the-loop: edit, tambah, atau hapus setiap butir.",
    "landing.groundB3": "Disclaimer profesional otomatis pada setiap laporan.",
    "landing.mockGeneric": "AI Generik",
    "landing.mockGenericQ": "\"Terjadi wanprestasi senilai ratusan juta.\" — sumber? entah.",
    "landing.mockGrounded": "Tergrounding ke Sumber",
    "landing.examplesSmall": "Contoh Nyata",
    "landing.examplesH2": "Lihat Lexiqa Bekerja — Contoh Hasil Analisis",
    "landing.examplesP": "Juri dan pengguna dapat menilai kualitas analisis kami sebelum masuk. Berikut empat keluaran nyata lintas bidang hukum yang telah dianonimkan.",
    "landing.recLabel": "Rekomendasi",
    "landing.confLabel": "Tingkat Keyakinan",
    "landing.reasonLabel": "Alasan:",
    "landing.examplesNote": "Hasil analisis ini merupakan rekomendasi berbasis AI sebagai alat bantu profesional. Keputusan akhir tetap berada pada penilaian legal analyst.",
    "landing.ex1badge": "Perkara Pidana",
    "landing.ex1jenis": "Tindak Pidana Penggelapan",
    "landing.ex1val": "Nilai Kerugian",
    "landing.ex1rec": "Lanjut ke Pengadilan (Litigasi)",
    "landing.ex1reason": "Unsur pidana terpenuhi, bukti dokumentasi kuat.",
    "landing.ex2badge": "Perkara Perdata",
    "landing.ex2jenis": "Sengketa Kontrak Komersial",
    "landing.ex2val": "Nilai Sengketa",
    "landing.ex2rec": "Penyelesaian di Luar Pengadilan (Mediasi)",
    "landing.ex2reason": "Nilai di bawah threshold litigasi optimal, hubungan bisnis masih aktif.",
    "landing.ex3badge": "Perkara Cyber Law",
    "landing.ex3jenis": "Pelanggaran UU ITE — Pencemaran Nama Baik Digital",
    "landing.ex3val": "Nilai Kerugian",
    "landing.ex3rec": "Mediasi Digital terlebih dahulu",
    "landing.ex3reason": "Regulasi masih berkembang, penyelesaian damai lebih efisien.",
    "landing.ex4badge": "Perkara TPIKOR",
    "landing.ex4jenis": "Tindak Pidana Korupsi Pengadaan Barang",
    "landing.ex4val": "Nilai Kerugian Negara",
    "landing.ex4rec": "Lanjut ke Pengadilan Tipikor",
    "landing.ex4reason": "Nilai kerugian negara signifikan, unsur korupsi terpenuhi, wajib proses hukum.",
    "landing.faqH2": "Pertanyaan yang Sering Diajukan",
    "landing.faq1q": "Apakah analisis Lexiqa akurat?",
    "landing.faq1a": "Lexiqa menggunakan AI yang tergrounding ke dokumen asli. Setiap fakta dan rekomendasi tertaut langsung ke sumber dokumen yang diunggah, bukan hasil halusinasi. Hasil analisis dirancang sebagai alat bantu profesional bagi legal analyst.",
    "landing.faq2q": "Apakah data dokumen saya aman?",
    "landing.faq2a": "Dokumen yang diunggah diproses secara aman, terenkripsi, dan tidak disimpan atau dibagikan ke pihak ketiga setelah analisis selesai.",
    "landing.faq3q": "Format dokumen apa yang didukung?",
    "landing.faq3a": "Lexiqa mendukung PDF dan DOCX. Dokumen scan pun bisa dibaca melalui teknologi OCR bawaan.",
    "landing.faq4q": "Berapa lama proses analisis berlangsung?",
    "landing.faq4a": "Sebagian besar dokumen dianalisis dalam hitungan menit, tergantung panjang dan kompleksitas dokumen.",
    "landing.faq5q": "Apa yang terjadi pada dokumen saya setelah analisis?",
    "landing.faq5a": "Setelah Laporan Akhir selesai dibuat, seluruh dokumen sumber Anda (berkas asli maupun teks hasil ekstraksi) dihapus permanen dari server dan penyimpanan kami. Hanya kutipan verbatim yang Anda perlukan untuk grounding yang tetap tersimpan di dalam laporan. Aplikasi menampilkan konfirmasi saat dokumen telah dihapus.",
    "landing.faq6q": "Bagaimana dengan pemrosesan AI — apakah data saya aman?",
    "landing.faq6a": "Teks dokumen dikirim ke penyedia AI Anthropic (model Claude, melalui infrastruktur Emergent) semata-mata untuk keperluan analisis. Penyedia TIDAK menyimpan dokumen Anda setelah pemrosesan dan TIDAK menggunakannya untuk melatih model AI. Rincian lengkap ada di Kebijakan Privasi kami.",
    "landing.testiSmall": "Testimoni",
    "landing.betaBadge": "Program Beta",
    "landing.testiH2": "Dipakai analis hukum Indonesia",
    "landing.testiP": "Lima analis dari program beta sedang menguji Lexiqa. Kutipan asli akan mengisi kartu di bawah ini setelah sesi selesai.",
    "landing.t1name": "Rizky Pratama",
    "landing.t1role": "Paralegal · Firma Hukum Litigasi Jakarta",
    "landing.t1quote": "Kutipan testimoni siap diisi setelah sesi beta — mis. seberapa cepat intake perkara & keandalan grounding ke dokumen sumber.",
    "landing.t2name": "Sari Wahyuni",
    "landing.t2role": "Junior Associate · Kantor Hukum Komersial",
    "landing.t2quote": "Kutipan testimoni siap diisi — mis. penghematan waktu menyusun kronologi dan daftar bukti.",
    "landing.t3name": "Dian Permata",
    "landing.t3role": "Legal Analyst · In-house Counsel BUMN",
    "landing.t3quote": "Kutipan testimoni siap diisi — mis. akurasi klasifikasi isu hukum dan kemudahan verifikasi sumber.",
    "landing.t4name": "Fauzi Hidayat",
    "landing.t4role": "Legal Consultant · Konsultan Hukum Independen",
    "landing.t4quote": "Kutipan testimoni siap diisi — mis. kualitas Laporan Akhir dan ekspor PDF/DOCX untuk klien.",
    "landing.t5name": "Mega Novita",
    "landing.t5role": "Paralegal · Lembaga Bantuan Hukum",
    "landing.t5quote": "Kutipan testimoni siap diisi — mis. manfaat OCR dokumen scan berbahasa Indonesia.",
    "landing.ctaH2": "Siap menganalisis perkara pertama Anda?",
    "landing.ctaP": "Masuk, unggah berkas, dan biarkan SOP 15-langkah menyusun laporan analisis perkara Anda.",
    "landing.footerDisclaimer": "Alat bantu analisis & penyusunan. Bukan nasihat hukum formal.",
    "landing.mockDocket1": "Ekstraksi Fakta",
    "landing.mockDocket2": "Klaim & Petitum",
    "landing.mockDocket3": "Poin Sengketa",
    "landing.mockDocket4": "Isu Hukum",
    "landing.mockFact": "Pada 10 Jan 2024, para pihak menandatangani Perjanjian Jual Beli No. 015/PJB/2024 senilai Rp500 juta.",
    "landing.mockQuote": "Kutipan Sumber",

    "login.leftP": "Analis perkara hukum bertenaga AI. Unggah berkas, biarkan SOP 15-langkah mengekstrak fakta, klaim, dan isu hukum — setiap temuan tertaut ke dokumen aslinya.",
    "login.leftFoot": "LCA-001 → LCA-015 · SOURCE-GROUNDED · BAHASA INDONESIA",
    "login.modeLogin": "Masuk ke workspace",
    "login.modeRegister": "Buat akun baru",
    "login.headLogin": "Selamat datang kembali",
    "login.headRegister": "Mulai analisis perkara",
    "login.name": "Nama",
    "login.namePh": "Nama lengkap",
    "login.emailPh": "anda@firma.id",
    "login.password": "Kata Sandi",
    "login.signIn": "Masuk",
    "login.register": "Daftar",
    "login.google": "Lanjutkan dengan Google",
    "login.toRegister": "Belum punya akun? Daftar",
    "login.toLogin": "Sudah punya akun? Masuk",
    "login.consent": "Saya menyetujui {tos} dan {privacy}",
    "login.consentTos": "Ketentuan Layanan",
    "login.consentPrivacy": "Kebijakan Privasi",
    "login.consentRequired": "Anda harus menyetujui Ketentuan Layanan dan Kebijakan Privasi",

    "pricing.h1": "Pilih paket Anda",
    "pricing.sub": "Harga dalam Rupiah. Pembayaran lokal via Xendit (QRIS, VA, e-wallet, kartu).",
    "pricing.adminBadge": "Akun admin · akses penuh tanpa batas",
    "pricing.perMo": "/bln",
    "pricing.yourPlan": "Paket Anda",
    "pricing.free": "Gratis",
    "pricing.activePlan": "Paket aktif",
    "pricing.upgradeTo": "Upgrade ke {name}",
    "pricing.freeF": "2 perkara|5 analisis AI / bulan|1 laporan / bulan",
    "pricing.proF": "Perkara tanpa batas|100 analisis AI / bulan|Ekspor tanpa watermark|Semua 15 tahap SOP",
    "pricing.bisnisF": "300 analisis AI / bulan|Prioritas pemrosesan|Dukungan prioritas",

    "dash.workspace": "Workspace",
    "dash.title": "Daftar Perkara",
    "dash.newCase": "Perkara Baru",
    "dash.titlePh": "Judul perkara — mis. PT Maju vs. CV Sentosa",
    "dash.descPh": "Deskripsi singkat (opsional)",
    "dash.create": "Buat Perkara",
    "dash.loading": "memuat perkara…",
    "dash.empty": "Belum ada perkara. Mulai dengan membuat perkara baru.",
    "dash.deleteConfirm": "Hapus perkara ini beserta seluruh dokumennya?",
    "dash.deleted": "Perkara dihapus",
    "dash.statusDraft": "Draf",
    "dash.statusAnalyzed": "Dianalisis",
    "dash.statusReported": "Laporan siap",
    "dash.quotaUnlimited": "Kuota tanpa batas",
    "dash.quotaLeft": "{remaining}/{limit} analisis tersisa",

    "ws.notFound": "Perkara tidak ditemukan",
    "ws.extracted": "{count} butir diekstrak & digrounding",
    "ws.analyzeSlow": "Analisis berjalan lama, menunggu hasil…",
    "ws.stageDone": "{code}: {count} butir · ringkasan tersusun",
    "ws.stageSlow": "Analisis tahap berjalan lama, menunggu hasil…",
    "ws.stageFinished": "Analisis {code} selesai",
    "ws.reportDone": "Laporan tersusun",
    "ws.reportSlow": "Penyusunan laporan berjalan lama, menunggu hasil…",
    "ws.itemDeleted": "Butir dihapus",
    "ws.filesStage": "Berkas {code}",
    "ws.analyzeStage": "Analisis AI Tahap Ini",
    "ws.allFiles": "Berkas Perkara (Semua Tahap)",
    "ws.allStages": "Semua Tahap",
    "ws.analysisItems": "Butir Analisis",
    "ws.addItem": "Tambah Butir",
    "ws.aiSummary": "Ringkasan Analisis AI",
    "ws.finalStageText": "Tahap final — klik Buat Laporan Akhir untuk mengompilasi seluruh butir grounded menjadi laporan.",
    "ws.emptyItems": "Belum ada butir untuk tahap ini. Unggah dokumen lalu klik Analisis AI, atau tambah butir manual.",
    "ws.genReport": "Buat Laporan Akhir",
    "ws.counts": "{items} butir · {docs} dok",

    "docket.title": "SOP Analisis",
    "docket.count": "{done}/{total} tahap",

    "upload.analyzing": "Menganalisis…",
    "upload.analyzeAI": "Analisis AI",
    "upload.drop": "Seret berkas atau klik untuk unggah",
    "upload.hint": "PDF · DOCX · gambar (OCR) · maks 15MB",
    "upload.uploaded": "{name} diunggah",
    "upload.pages": "{n} hal",

    "item.manual": "manual",
    "item.edited": "diedit",
    "chip.page": "hal. {n}",
    "chip.source": "sumber",
    "chip.quoteTitle": "Kutipan Sumber",
    "chrono.empty": "Belum ada peristiwa bertanggal. Kronologi tersusun otomatis dari fakta yang memiliki tanggal.",

    "editor.editTitle": "Edit Butir",
    "editor.addTitle": "Tambah Butir Manual",
    "editor.category": "Kategori",
    "editor.content": "Isi Butir",
    "editor.snippet": "Kutipan Sumber (verbatim)",
    "editor.snippetPh": "Salin kutipan persis dari dokumen…",
    "editor.page": "Halaman",
    "editor.date": "Tanggal (opsional)",
    "editor.sourceDoc": "Dokumen Sumber",
    "editor.pickDoc": "Pilih dokumen…",
    "editor.emptyError": "Isi butir tidak boleh kosong",
    "editor.updated": "Butir diperbarui",
    "editor.added": "Butir ditambahkan",

    "report.title": "Laporan Analisis Perkara",
    "report.regen": "Susun ulang",
    "report.compose": "Susun",
    "report.generating": "Claude Sonnet 4.6 menyusun laporan…",
    "report.empty": "Laporan belum dibuat. Klik Susun untuk mengompilasi seluruh butir grounded menjadi laporan analisis perkara.",
    "report.summary": "Ringkasan Perkara",
    "report.sitasi": "Sitasi & Informasi Dasar",
    "report.facts": "Pendahuluan & Fakta Kasus",
    "report.args": "Argumen Para Pihak",
    "report.reasoning": "Penalaran & Analisis",
    "report.holding": "Putusan & Ratio Decidendi",
    "report.critique": "Analisis Kritis",
    "report.conclusion": "Kesimpulan",
    "report.caseName": "Nama Kasus",
    "report.caseNumber": "Nomor Perkara",
    "report.court": "Pengadilan",
    "report.date": "Tanggal",
    "report.judges": "Majelis Hakim",
    "report.docType": "Jenis Dokumen",
    "job.reading": "Membaca dokumen…",
    "job.extracting": "Menganalisis fakta, klaim & isu hukum…",
    "job.saving": "Menyimpan butir analisis…",
    "job.collecting": "Mengumpulkan butir grounded…",
    "job.composing": "Menyusun laporan…",
    "job.purging": "Menghapus dokumen sumber secara permanen…",
    "job.hint": "Proses berjalan di server. Anda boleh menutup jendela ini atau memuat ulang halaman — progres akan dilanjutkan.",
    "report.ratioDecidendi": "Ratio Decidendi",
    "report.ratioLegis": "Ratio Legis",
    "report.scope": "Lingkup Berlaku",
    "report.coreNorms": "Norma Inti",
    "report.rdRule": "Kaidah Hukum",
    "report.rdFacts": "Fakta Material",
    "report.rdObiter": "Obiter Dicta",
    "report.rdLimits": "Batas Penerapan",
    "report.rdAuthority": "Nilai Otoritas",
    "report.type_putusan": "Putusan Pengadilan",
    "report.type_peraturan": "Peraturan Perundang-undangan",
    "report.type_campuran": "Campuran (Putusan & Peraturan)",
    "report.type_lainnya": "Dokumen Lainnya",
    "report.parties": "Para Pihak",
    "report.chronology": "Kronologi",
    "report.issues": "Isu Hukum",
    "report.analysis": "Analisis Yuridis",
    "report.risk": "Penilaian Risiko",
    "report.reco": "Rekomendasi Strategi",
    "report.disclaimer": "Dokumen ini dihasilkan oleh Lexiqa sebagai alat bantu analisis. Ini BUKAN nasihat hukum formal. Verifikasi setiap temuan terhadap dokumen sumber dan konsultasikan dengan advokat berlisensi sebelum mengambil keputusan hukum.",
    "report.downloaded": "Laporan {format} diunduh",
    "report.purged": "Dokumen sumber telah dihapus permanen dari server kami.",
    "report.purgedToast": "Laporan selesai — {count} dokumen sumber dihapus permanen dari server.",

    "billing.thanks": "Terima kasih!",
    "billing.cancelled": "Pembayaran dibatalkan",
    "billing.cancelledP": "Transaksi tidak diselesaikan. Anda bisa mencoba lagi kapan saja.",
    "billing.pendingP": "Pembayaran sedang dikonfirmasi. Paket akan aktif otomatis setelah terverifikasi",
    "billing.currentPlan": " (paket saat ini: {plan}).",
    "billing.toDashboard": "Ke Dashboard",
    "billing.viewPlans": "Lihat Paket",

    "auth.preparing": "Menyiapkan sesi…",

    "cat.Fakta": "Fakta",

    "privacy.title": "Kebijakan Privasi",
    "privacy.updated": "Terakhir diperbarui: 1 Oktober 2026",
    "privacy.backHome": "Kembali ke Beranda",
    "privacy.intro": "Lexiqa menghormati kerahasiaan dokumen hukum Anda. Kebijakan ini menjelaskan bagaimana kami menangani data Anda, khususnya dokumen perkara yang Anda unggah dan pemrosesannya oleh AI.",
    "privacy.s1t": "1. Penyimpanan & Penghapusan Dokumen",
    "privacy.s1a": "Dokumen yang Anda unggah disimpan sementara hanya selama proses analisis berlangsung.",
    "privacy.s1b": "Setelah Laporan Akhir selesai dibuat, SELURUH dokumen sumber Anda — baik berkas asli di penyimpanan maupun teks hasil ekstraksi di basis data — dihapus secara permanen dari server kami.",
    "privacy.s1c": "Tidak ada salinan berkas asli yang dipertahankan. Hanya kutipan verbatim yang diperlukan untuk grounding temuan yang tetap tersimpan di dalam laporan akhir Anda.",
    "privacy.s1d": "Aplikasi menampilkan konfirmasi di layar saat dokumen telah dihapus.",
    "privacy.s2t": "2. Pemrosesan oleh AI",
    "privacy.s2a": "Untuk menganalisis perkara, teks dokumen Anda dikirim ke penyedia AI pihak ketiga: Anthropic (model Claude — Claude Haiku untuk ekstraksi, Claude Sonnet untuk penyusunan laporan), diakses melalui infrastruktur Emergent.",
    "privacy.s2b": "Pengiriman ini dilakukan SEMATA-MATA untuk keperluan analisis atas permintaan Anda.",
    "privacy.s2c": "Penyedia AI TIDAK menyimpan dokumen Anda setelah pemrosesan selesai.",
    "privacy.s2d": "Dokumen Anda TIDAK digunakan untuk melatih atau menyempurnakan model AI mana pun.",
    "privacy.s3t": "3. Data Akun",
    "privacy.s3a": "Kami menyimpan alamat email, nama, paket langganan, dan catatan persetujuan Anda (termasuk waktu dan versi dokumen hukum yang disetujui). Data ini digunakan untuk mengelola akun dan layanan Anda.",
    "privacy.s4t": "4. Persetujuan",
    "privacy.s4a": "Dengan mendaftar, Anda menyetujui Ketentuan Layanan dan Kebijakan Privasi ini. Persetujuan Anda dicatat beserta waktunya di basis data kami.",
    "privacy.s5t": "5. Kontak",
    "privacy.s5a": "Pertanyaan terkait privasi dapat diajukan melalui kanal dukungan resmi Lexiqa.",

    "cat.Klaim": "Klaim",
    "cat.Disengketakan": "Disengketakan",
    "cat.Bukti": "Bukti",
    "cat.Isu_Hukum": "Isu Hukum",

    "sop.LCA-001.title": "Intake & Registrasi Dokumen",
    "sop.LCA-001.desc": "Menerima dan mendaftarkan seluruh berkas perkara.",
    "sop.LCA-002.title": "Identifikasi Para Pihak",
    "sop.LCA-002.desc": "Menentukan penggugat, tergugat, dan pihak terkait.",
    "sop.LCA-003.title": "Klasifikasi Jenis Perkara",
    "sop.LCA-003.desc": "Perdata, pidana, TUN, niaga, atau lainnya.",
    "sop.LCA-004.title": "Ekstraksi Fakta Material",
    "sop.LCA-004.desc": "Mengumpulkan fakta-fakta penting dari dokumen.",
    "sop.LCA-005.title": "Identifikasi Klaim & Petitum",
    "sop.LCA-005.desc": "Mengidentifikasi tuntutan dan dalil para pihak.",
    "sop.LCA-006.title": "Inventarisasi Bukti",
    "sop.LCA-006.desc": "Mendata seluruh alat bukti yang tersedia.",
    "sop.LCA-007.title": "Identifikasi Poin Sengketa",
    "sop.LCA-007.desc": "Menentukan hal-hal yang diperselisihkan.",
    "sop.LCA-008.title": "Rekonstruksi Kronologi",
    "sop.LCA-008.desc": "Menyusun urutan peristiwa berdasarkan fakta.",
    "sop.LCA-009.title": "Identifikasi Isu Hukum",
    "sop.LCA-009.desc": "Merumuskan persoalan hukum yang harus dijawab.",
    "sop.LCA-010.title": "Analisis Dasar Hukum",
    "sop.LCA-010.desc": "Menemukan peraturan dan yurisprudensi relevan.",
    "sop.LCA-011.title": "Analisis Posisi (SWOT)",
    "sop.LCA-011.desc": "Menilai kekuatan dan kelemahan posisi hukum.",
    "sop.LCA-012.title": "Penilaian Risiko",
    "sop.LCA-012.desc": "Mengukur risiko litigasi dan potensi hasil.",
    "sop.LCA-013.title": "Rekomendasi Strategi",
    "sop.LCA-013.desc": "Menyusun strategi penanganan perkara.",
    "sop.LCA-014.title": "Verifikasi Grounding & Sumber",
    "sop.LCA-014.desc": "Memastikan setiap temuan terhubung ke sumber.",
    "sop.LCA-015.title": "Kompilasi Laporan Akhir",
    "sop.LCA-015.desc": "Menyusun Laporan Intelijen Perkara final.",
  },

  en: {
    "common.guide": "Guide",
    "common.manualDownload": "Download User Guide (PDF)",
    "common.login": "Sign in",
    "common.logout": "Sign out",
    "common.startAnalysis": "Start Analysis",
    "common.loading": "loading…",
    "common.or": "or",
    "common.save": "Save",
    "common.upgrade": "Upgrade",
    "unit.docs": "docs",
    "unit.items": "items",

    "landing.badge": "AI-Powered Legal Analysis",
    "landing.heroA": "Case analysis,",
    "landing.heroB": "grounded",
    "landing.heroC": " to every source.",
    "landing.heroSub": "LEXIQA — AI-powered case intelligence",
    "landing.heroDesc": "Case files, commercial contracts, or investigation reports often run hundreds to thousands of pages. Our platform tackles information overload — scanning, summarizing chronologies, and extracting key facts in minutes.",
    "landing.stat1": "SOP stages",
    "landing.stat2": "Grounded categories",
    "landing.stat3": "Not days",
    "landing.stat4": "One-click export",
    "landing.howSmall": "How It Works",
    "landing.howH2": "Three steps to a report",
    "landing.step1t": "Upload Files",
    "landing.step1d": "Drag lawsuits, contracts, evidence, or verdicts. Scanned documents are read via OCR.",
    "landing.step2t": "AI Analysis",
    "landing.step2d": "AI extracts facts, claims, disputes, evidence, and legal issues across the 15-step SOP.",
    "landing.step3t": "Final Report",
    "landing.step3d": "Automatically compiled into a case analysis report — grounded & export-ready.",
    "landing.featSmall": "Core Capabilities",
    "landing.featH2": "From raw files to litigation strategy",
    "landing.feat1t": "Scan & Summarize",
    "landing.feat1d": "Scans hundreds of pages of lawsuits, contracts, or reports and summarizes them in minutes.",
    "landing.feat2t": "Automatic Chronology",
    "landing.feat2d": "Reconstructs the case timeline automatically from extracted facts.",
    "landing.feat3t": "Analysis Report",
    "landing.feat3d": "One click produces the Case Analysis Report — ready to export as PDF & DOCX.",
    "landing.feat4t": "Source-Grounded",
    "landing.feat4d": "Every fact & legal issue links to the original document + verbatim quote — anti-hallucination.",
    "landing.groundBadge": "Credibility Moat",
    "landing.groundH2": "Not just AI output — analysis you can defend.",
    "landing.groundP": "Every lawyer's first question: \"is the AI hallucinating?\" That's the difference here. Every fact, claim, and legal issue stores a verbatim quote from the original document with its page number — one click to verify.",
    "landing.groundB1": "Verbatim quotes are stored at extraction — no extra AI cost.",
    "landing.groundB2": "Human-in-the-loop: edit, add, or delete any item.",
    "landing.groundB3": "Automatic professional disclaimer on every report.",
    "landing.mockGeneric": "Generic AI",
    "landing.mockGenericQ": "\"A breach worth hundreds of millions occurred.\" — source? unknown.",
    "landing.mockGrounded": "Source-Grounded",
    "landing.examplesSmall": "Real Examples",
    "landing.examplesH2": "See Lexiqa at Work — Sample Analysis Output",
    "landing.examplesP": "Reviewers and users can judge our analysis quality before signing in. Here are four real, anonymized outputs across legal domains.",
    "landing.recLabel": "Recommendation",
    "landing.confLabel": "Confidence Level",
    "landing.reasonLabel": "Reasoning:",
    "landing.examplesNote": "This analysis is an AI-based recommendation as a professional aid. The final decision remains with the legal analyst's judgment.",
    "landing.ex1badge": "Criminal Case",
    "landing.ex1jenis": "Criminal Embezzlement",
    "landing.ex1val": "Loss Amount",
    "landing.ex1rec": "Proceed to Court (Litigation)",
    "landing.ex1reason": "Criminal elements fulfilled, strong documentary evidence.",
    "landing.ex2badge": "Civil Case",
    "landing.ex2jenis": "Commercial Contract Dispute",
    "landing.ex2val": "Dispute Value",
    "landing.ex2rec": "Out-of-Court Settlement (Mediation)",
    "landing.ex2reason": "Value below optimal litigation threshold, business relationship still active.",
    "landing.ex3badge": "Cyber Law Case",
    "landing.ex3jenis": "ITE Act Violation — Digital Defamation",
    "landing.ex3val": "Loss Amount",
    "landing.ex3rec": "Digital Mediation first",
    "landing.ex3reason": "Regulations still evolving, amicable settlement is more efficient.",
    "landing.ex4badge": "Corruption Case",
    "landing.ex4jenis": "Procurement Corruption Crime",
    "landing.ex4val": "State Loss Amount",
    "landing.ex4rec": "Proceed to Corruption Court",
    "landing.ex4reason": "Significant state losses, corruption elements fulfilled, legal process required.",
    "landing.faqH2": "Frequently Asked Questions",
    "landing.faq1q": "Is Lexiqa's analysis accurate?",
    "landing.faq1a": "Lexiqa uses AI grounded to the original documents. Every fact and recommendation links directly to the uploaded source document — not hallucinated output. The analysis is designed as a professional aid for legal analysts.",
    "landing.faq2q": "Is my document data secure?",
    "landing.faq2a": "Uploaded documents are processed securely and encrypted, and are not stored or shared with third parties after analysis completes.",
    "landing.faq3q": "What document formats are supported?",
    "landing.faq3a": "Lexiqa supports PDF and DOCX. Scanned documents can also be read through built-in OCR technology.",
    "landing.faq4q": "How long does analysis take?",
    "landing.faq4a": "Most documents are analyzed within minutes, depending on document length and complexity.",
    "landing.faq5q": "What happens to my documents after analysis?",
    "landing.faq5a": "Once the Final Report is generated, all your source documents (both the original files and the extracted text) are permanently deleted from our servers and storage. Only the verbatim quotes you need for grounding remain inside the report. The app shows a confirmation once documents are deleted.",
    "landing.faq6q": "What about AI processing — is my data safe?",
    "landing.faq6a": "Document text is sent to the AI provider Anthropic (Claude models, via Emergent infrastructure) solely for analysis. The provider does NOT store your documents after processing and does NOT use them to train AI models. Full details are in our Privacy Policy.",
    "landing.testiSmall": "Testimonials",
    "landing.betaBadge": "Beta Program",
    "landing.testiH2": "Used by legal analysts",
    "landing.testiP": "Five analysts from the beta program are testing Lexiqa. Real quotes will fill the cards below once the sessions conclude.",
    "landing.t1name": "Rizky Pratama",
    "landing.t1role": "Paralegal · Litigation Law Firm, Jakarta",
    "landing.t1quote": "Testimonial quote ready to be filled after the beta session — e.g. how fast case intake is & reliability of source grounding.",
    "landing.t2name": "Sari Wahyuni",
    "landing.t2role": "Junior Associate · Commercial Law Office",
    "landing.t2quote": "Testimonial quote ready to be filled — e.g. time saved building chronologies and evidence lists.",
    "landing.t3name": "Dian Permata",
    "landing.t3role": "Legal Analyst · SOE In-house Counsel",
    "landing.t3quote": "Testimonial quote ready to be filled — e.g. accuracy of legal issue classification and ease of source verification.",
    "landing.t4name": "Fauzi Hidayat",
    "landing.t4role": "Legal Consultant · Independent Practice",
    "landing.t4quote": "Testimonial quote ready to be filled — e.g. quality of the Final Report and PDF/DOCX export for clients.",
    "landing.t5name": "Mega Novita",
    "landing.t5role": "Paralegal · Legal Aid Institute",
    "landing.t5quote": "Testimonial quote ready to be filled — e.g. benefits of OCR for scanned documents.",
    "landing.ctaH2": "Ready to analyze your first case?",
    "landing.ctaP": "Sign in, upload your files, and let the 15-step SOP build your case analysis report.",
    "landing.footerDisclaimer": "An analysis & drafting aid. Not formal legal advice.",
    "landing.mockDocket1": "Fact Extraction",
    "landing.mockDocket2": "Claims & Reliefs",
    "landing.mockDocket3": "Disputed Points",
    "landing.mockDocket4": "Legal Issues",
    "landing.mockFact": "On 10 Jan 2024, the parties signed Sale & Purchase Agreement No. 015/PJB/2024 worth IDR 500 million.",
    "landing.mockQuote": "Source Quote",

    "login.leftP": "An AI-powered legal case analyst. Upload your files and let the 15-step SOP extract facts, claims, and legal issues — every finding linked to its original document.",
    "login.leftFoot": "LCA-001 → LCA-015 · SOURCE-GROUNDED · ID / EN",
    "login.modeLogin": "Sign in to workspace",
    "login.modeRegister": "Create a new account",
    "login.headLogin": "Welcome back",
    "login.headRegister": "Start case analysis",
    "login.name": "Name",
    "login.namePh": "Full name",
    "login.emailPh": "you@firm.com",
    "login.password": "Password",
    "login.signIn": "Sign in",
    "login.register": "Sign up",
    "login.google": "Continue with Google",
    "login.toRegister": "No account yet? Sign up",
    "login.toLogin": "Already have an account? Sign in",
    "login.consent": "I agree to the {tos} and {privacy}",
    "login.consentTos": "Terms of Service",
    "login.consentPrivacy": "Privacy Policy",
    "login.consentRequired": "You must agree to the Terms of Service and Privacy Policy",

    "pricing.h1": "Choose your plan",
    "pricing.sub": "Prices in Rupiah. Local payments via Xendit (QRIS, VA, e-wallets, cards).",
    "pricing.adminBadge": "Admin account · full unlimited access",
    "pricing.perMo": "/mo",
    "pricing.yourPlan": "Your plan",
    "pricing.free": "Free",
    "pricing.activePlan": "Active plan",
    "pricing.upgradeTo": "Upgrade to {name}",
    "pricing.freeF": "2 cases|5 AI analyses / month|1 report / month",
    "pricing.proF": "Unlimited cases|100 AI analyses / month|Watermark-free export|All 15 SOP stages",
    "pricing.bisnisF": "300 AI analyses / month|Processing priority|Priority support",

    "dash.workspace": "Workspace",
    "dash.title": "Case List",
    "dash.newCase": "New Case",
    "dash.titlePh": "Case title — e.g. Acme Corp vs. Globex",
    "dash.descPh": "Short description (optional)",
    "dash.create": "Create Case",
    "dash.loading": "loading cases…",
    "dash.empty": "No cases yet. Start by creating a new case.",
    "dash.deleteConfirm": "Delete this case and all its documents?",
    "dash.deleted": "Case deleted",
    "dash.statusDraft": "Draft",
    "dash.statusAnalyzed": "Analyzed",
    "dash.statusReported": "Report ready",
    "dash.quotaUnlimited": "Unlimited quota",
    "dash.quotaLeft": "{remaining}/{limit} analyses left",

    "ws.notFound": "Case not found",
    "ws.extracted": "{count} items extracted & grounded",
    "ws.analyzeSlow": "Analysis is taking a while, waiting for results…",
    "ws.stageDone": "{code}: {count} items · summary composed",
    "ws.stageSlow": "Stage analysis is taking a while, waiting for results…",
    "ws.stageFinished": "Analysis {code} finished",
    "ws.reportDone": "Report composed",
    "ws.reportSlow": "Report composition is taking a while, waiting for results…",
    "ws.itemDeleted": "Item deleted",
    "ws.filesStage": "{code} Files",
    "ws.analyzeStage": "Analyze This Stage",
    "ws.allFiles": "Case Files (All Stages)",
    "ws.allStages": "All Stages",
    "ws.analysisItems": "Analysis Items",
    "ws.addItem": "Add Item",
    "ws.aiSummary": "AI Analysis Summary",
    "ws.finalStageText": "Final stage — click Generate Final Report to compile all grounded items into a report.",
    "ws.emptyItems": "No items for this stage yet. Upload documents then click AI Analysis, or add items manually.",
    "ws.genReport": "Generate Final Report",
    "ws.counts": "{items} items · {docs} docs",

    "docket.title": "Analysis SOP",
    "docket.count": "{done}/{total} stages",

    "upload.analyzing": "Analyzing…",
    "upload.analyzeAI": "AI Analysis",
    "upload.drop": "Drag files or click to upload",
    "upload.hint": "PDF · DOCX · images (OCR) · max 15MB",
    "upload.uploaded": "{name} uploaded",
    "upload.pages": "{n} pg",

    "item.manual": "manual",
    "item.edited": "edited",
    "chip.page": "p. {n}",
    "chip.source": "source",
    "chip.quoteTitle": "Source Quote",
    "chrono.empty": "No dated events yet. The chronology is built automatically from facts that have dates.",

    "editor.editTitle": "Edit Item",
    "editor.addTitle": "Add Manual Item",
    "editor.category": "Category",
    "editor.content": "Item Content",
    "editor.snippet": "Source Quote (verbatim)",
    "editor.snippetPh": "Paste the exact quote from the document…",
    "editor.page": "Page",
    "editor.date": "Date (optional)",
    "editor.sourceDoc": "Source Document",
    "editor.pickDoc": "Select document…",
    "editor.emptyError": "Item content must not be empty",
    "editor.updated": "Item updated",
    "editor.added": "Item added",

    "report.title": "Case Analysis Report",
    "report.regen": "Regenerate",
    "report.compose": "Generate",
    "report.generating": "Claude Sonnet 4.6 is composing the report…",
    "report.empty": "No report yet. Click Generate to compile all grounded items into a case analysis report.",
    "report.summary": "Case Summary",
    "report.sitasi": "Citation & Basic Information",
    "report.facts": "Introduction & Case Facts",
    "report.args": "Parties' Arguments",
    "report.reasoning": "Reasoning & Analysis",
    "report.holding": "Holding & Ratio Decidendi",
    "report.critique": "Critical Analysis",
    "report.conclusion": "Conclusion",
    "report.caseName": "Case Name",
    "report.caseNumber": "Case Number",
    "report.court": "Court",
    "report.date": "Date",
    "report.judges": "Panel of Judges",
    "report.docType": "Document Type",
    "job.reading": "Reading documents…",
    "job.extracting": "Analyzing facts, claims & legal issues…",
    "job.saving": "Saving analysis items…",
    "job.collecting": "Collecting grounded items…",
    "job.composing": "Composing report…",
    "job.purging": "Permanently deleting source documents…",
    "job.hint": "This runs on the server. You can close this window or reload the page — progress will resume.",
    "report.ratioDecidendi": "Ratio Decidendi",
    "report.ratioLegis": "Ratio Legis",
    "report.scope": "Scope of Application",
    "report.coreNorms": "Core Norms",
    "report.rdRule": "Legal Rule",
    "report.rdFacts": "Material Facts",
    "report.rdObiter": "Obiter Dicta",
    "report.rdLimits": "Limits of Application",
    "report.rdAuthority": "Authoritative Value",
    "report.type_putusan": "Court Decision",
    "report.type_peraturan": "Statute / Regulation",
    "report.type_campuran": "Mixed (Decision & Regulation)",
    "report.type_lainnya": "Other Document",
    "report.parties": "Parties",
    "report.chronology": "Chronology",
    "report.issues": "Legal Issues",
    "report.analysis": "Legal Analysis",
    "report.risk": "Risk Assessment",
    "report.reco": "Strategy Recommendations",
    "report.disclaimer": "This document was generated by Lexiqa as an analysis aid. It is NOT formal legal advice. Verify every finding against the source documents and consult a licensed attorney before making legal decisions.",
    "report.downloaded": "Report {format} downloaded",
    "report.purged": "Source documents have been permanently deleted from our servers.",
    "report.purgedToast": "Report ready — {count} source documents permanently deleted from the server.",

    "billing.thanks": "Thank you!",
    "billing.cancelled": "Payment cancelled",
    "billing.cancelledP": "The transaction was not completed. You can try again anytime.",
    "billing.pendingP": "Payment is being confirmed. Your plan will activate automatically once verified",
    "billing.currentPlan": " (current plan: {plan}).",
    "billing.toDashboard": "Go to Dashboard",
    "billing.viewPlans": "View Plans",

    "auth.preparing": "Preparing your session…",

    "cat.Fakta": "Fact",

    "privacy.title": "Privacy Policy",
    "privacy.updated": "Last updated: 1 October 2026",
    "privacy.backHome": "Back to Home",
    "privacy.intro": "Lexiqa respects the confidentiality of your legal documents. This policy explains how we handle your data, in particular the case documents you upload and their processing by AI.",
    "privacy.s1t": "1. Document Storage & Deletion",
    "privacy.s1a": "Documents you upload are stored temporarily only for the duration of the analysis.",
    "privacy.s1b": "Once the Final Report is generated, ALL your source documents — both the original files in storage and the extracted text in the database — are permanently deleted from our servers.",
    "privacy.s1c": "No copy of the original file is retained. Only the verbatim quotes required to ground your findings remain inside your final report.",
    "privacy.s1d": "The app displays an on-screen confirmation once documents are deleted.",
    "privacy.s2t": "2. AI Processing",
    "privacy.s2a": "To analyze a case, your document text is sent to a third-party AI provider: Anthropic (Claude models — Claude Haiku for extraction, Claude Sonnet for report drafting), accessed via Emergent infrastructure.",
    "privacy.s2b": "This transmission is done SOLELY for analysis at your request.",
    "privacy.s2c": "The AI provider does NOT store your documents after processing completes.",
    "privacy.s2d": "Your documents are NOT used to train or fine-tune any AI model.",
    "privacy.s3t": "3. Account Data",
    "privacy.s3a": "We store your email address, name, subscription plan, and consent record (including the time and the version of the legal documents you agreed to). This data is used to manage your account and service.",
    "privacy.s4t": "4. Consent",
    "privacy.s4a": "By registering, you agree to these Terms of Service and Privacy Policy. Your consent is recorded with its timestamp in our database.",
    "privacy.s5t": "5. Contact",
    "privacy.s5a": "Privacy questions may be directed to Lexiqa's official support channels.",

    "cat.Klaim": "Claim",
    "cat.Disengketakan": "Disputed",
    "cat.Bukti": "Evidence",
    "cat.Isu_Hukum": "Legal Issue",

    "sop.LCA-001.title": "Document Intake & Registration",
    "sop.LCA-001.desc": "Receive and register all case files.",
    "sop.LCA-002.title": "Parties Identification",
    "sop.LCA-002.desc": "Identify plaintiffs, defendants, and related parties.",
    "sop.LCA-003.title": "Case Type Classification",
    "sop.LCA-003.desc": "Civil, criminal, administrative, commercial, or other.",
    "sop.LCA-004.title": "Material Fact Extraction",
    "sop.LCA-004.desc": "Gather key facts from the documents.",
    "sop.LCA-005.title": "Claims & Reliefs Identification",
    "sop.LCA-005.desc": "Identify the parties' claims and arguments.",
    "sop.LCA-006.title": "Evidence Inventory",
    "sop.LCA-006.desc": "Catalogue all available evidence.",
    "sop.LCA-007.title": "Disputed Points Identification",
    "sop.LCA-007.desc": "Determine the matters in dispute.",
    "sop.LCA-008.title": "Chronology Reconstruction",
    "sop.LCA-008.desc": "Build the sequence of events from the facts.",
    "sop.LCA-009.title": "Legal Issue Identification",
    "sop.LCA-009.desc": "Formulate the legal questions to be answered.",
    "sop.LCA-010.title": "Legal Basis Analysis",
    "sop.LCA-010.desc": "Find relevant regulations and jurisprudence.",
    "sop.LCA-011.title": "Position Analysis (SWOT)",
    "sop.LCA-011.desc": "Assess strengths and weaknesses of the legal position.",
    "sop.LCA-012.title": "Risk Assessment",
    "sop.LCA-012.desc": "Measure litigation risk and potential outcomes.",
    "sop.LCA-013.title": "Strategy Recommendation",
    "sop.LCA-013.desc": "Develop the case-handling strategy.",
    "sop.LCA-014.title": "Grounding & Source Verification",
    "sop.LCA-014.desc": "Ensure every finding links to its source.",
    "sop.LCA-015.title": "Final Report Compilation",
    "sop.LCA-015.desc": "Compile the final Case Intelligence Report.",
  },
};

const LangCtx = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lexiqa_lang") || "id");
  const setLang = useCallback((l) => {
    localStorage.setItem("lexiqa_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key, vars) => {
    let s = T[lang]?.[key] ?? T.id[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
    return s;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
}

export function useI18n() {
  return useContext(LangCtx);
}

export function sopTitle(t, s) {
  return t(`sop.${s.code}.title`);
}

export function sopDesc(t, s) {
  return t(`sop.${s.code}.desc`);
}
